import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@bluframe/mightychroma-mightytool-ui";
import React from "react";
import { H1, Wrapper } from "./styled";
const Profile = ({ me, onLogout }) => (_jsxs(Wrapper, { children: [_jsx(H1, { children: me?.firstName }), _jsx(Button, { label: "Logout", onClick: onLogout })] }));
export default Profile;
